import React, { useMemo } from 'react';
import { InputTime, useFormContext } from '@goodfynd/forms';
import { FlexView } from '@goodfynd/ui';
import { Text } from '@goodfynd/ui';
import { stringUtil } from '@goodfynd/utils';
import { dateUtil, eventUtil } from 'utils/index';

import type { ScheduleWizardFields } from './types';

export function StepOperatingHours() {
  const { control, watch } = useFormContext<ScheduleWizardFields>();
  const end = watch('end');
  const start = watch('start');

  const durationDisplay = useMemo(
    () =>
      stringUtil.durationDisplay({
        end: end ?? new Date(),
        start: start ?? new Date(),
      }),
    [end, start]
  );

  return (
    <FlexView direction="column" gap={16}>
      <Text as="body2">When will you be vending?</Text>

      <FlexView direction="column" gap={0} margin="0 0 24px" width="100%">
        <InputTime<ScheduleWizardFields>
          control={control}
          fullWidth
          helperText={durationDisplay}
          label="Start time"
          name="start"
        />

        <InputTime<ScheduleWizardFields>
          control={control}
          fullWidth
          label="End time"
          name="end"
          presets={
            start
              ? [
                  dateUtil.addHours(start, 2),
                  dateUtil.addHours(start, 3),
                  dateUtil.addHours(start, 4),
                  dateUtil.addHours(start, 8),
                ]
              : []
          }
        />
      </FlexView>
    </FlexView>
  );
}

export function StepOperatingHoursSummary() {
  const { getValues } = useFormContext<ScheduleWizardFields>();
  const { end, start } = getValues();
  const interval = { end, start } as IntervalDates;

  return (
    <div>
      <Text id="interval">
        {eventUtil.getEventTimeLabel(interval)}&nbsp;(
        {dateUtil.durationDisplay(interval, '')?.trim()})
      </Text>
    </div>
  );
}
